export default __webpack_public_path__ + "static/18-4b0e7e7ed9559fc275694ac6df302d7e.webp";